export default __webpack_public_path__ + "static/media/icon-unassign.2ade1f3b.svg";